const CandidateGroupTypes = {
  CREATE_CANDIDATE_GROUP: 'CREATE_CANDIDATE_GROUP',
  CREATE_CANDIDATE_GROUP_SUCCESS: 'CREATE_CANDIDATE_GROUP_SUCCESS',
  CREATE_CANDIDATE_GROUP_FAILURE: 'CREATE_CANDIDATE_GROUP_FAILURE',

  EDIT_CANDIDATE_GROUP: 'EDIT_CANDIDATE_GROUP',
  EDIT_CANDIDATE_GROUP_SUCCESS: 'EDIT_CANDIDATE_GROUP_SUCCESS',
  EDIT_CANDIDATE_GROUP_FAILURE: 'EDIT_CANDIDATE_GROUP_FAILURE',

  UPDATE_CANDIDATE_GROUP_HEADERS: 'UPDATE_CANDIDATE_GROUP_HEADERS',
  UPDATE_CANDIDATE_GROUP_HEADERS_SUCCESS: 'UPDATE_CANDIDATE_GROUP_SUCCESS_HEADERS',
  UPDATE_CANDIDATE_GROUP_HEADERS_FAILURE: 'UPDATE_CANDIDATE_GROUP_FAILURE_HEADERS',

  DELETE_CANDIDATE_GROUP: 'DELETE_CANDIDATE_GROUP',
  DELETE_CANDIDATE_GROUP_SUCCESS: 'DELETE_CANDIDATE_GROUP_SUCCESS',
  DELETE_CANDIDATE_GROUP_FAILURE: 'DELETE_CANDIDATE_GROUP_FAILURE',

  FETCH_CANDIDATE_GROUP: 'FETCH_CANDIDATE_GROUP',
  FETCH_CANDIDATE_GROUP_SUCCESS: 'FETCH_CANDIDATE_GROUP_SUCCESS',
  FETCH_CANDIDATE_GROUP_FAILURE: 'FETCH_CANDIDATE_GROUP_FAILURE',
};

export default CandidateGroupTypes;
